// Global
import { Switch } from 'antd';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { getPages, selectCurrentPageIsLoading, updatePage } from '../../feature';

// Model
import { IBasePage } from '@/models/page.model';

// UI
import { PopConfirm } from '@/ui';

interface Props {
  page: IBasePage;
  channelId?: number;
}

export const SitemapSwitch: FC<Props> = ({ page, channelId }) => {
  const { t } = useTranslation(['common']);
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectCurrentPageIsLoading);

  const handleChange = useCallback(async () => {
    if (!channelId) {
      return;
    }

    try {
      await dispatch(
        updatePage({
          pageId: page.id,
          data: {
            type: page.type,
            enabledInSitemap: page.enabledInSitemap ? false : true,
          },
        }),
      ).unwrap();
      await dispatch(
        getPages({
          channelId: channelId,
        }),
      );
    } catch (error) {
      console.error(error);
    }
  }, [page, channelId, dispatch]);

  return (
    <div onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
      <PopConfirm
        title={t(page.enabledInSitemap ? 'modal_page_sitemap_disable_title' : 'modal_page_sitemap_enable_title')}
        onConfirm={handleChange}
      >
        <Switch
          checkedChildren={'ENABLED'}
          checked={page.enabledInSitemap}
          defaultValue={page.enabledInSitemap}
          unCheckedChildren={'DISABLED'}
          loading={isLoading}
        />
      </PopConfirm>
    </div>
  );
};
